import { render, staticRenderFns } from "./instructorIndex.vue?vue&type=template&id=55ef10cd&scoped=true&"
import script from "./instructorIndex.vue?vue&type=script&lang=js&"
export * from "./instructorIndex.vue?vue&type=script&lang=js&"
import style0 from "./instructorIndex.vue?vue&type=style&index=0&id=55ef10cd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ef10cd",
  null
  
)

export default component.exports